import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';
import { DrawerContainer } from '../Drawer/DrawerContainer';
import Swiper, { FreeMode, Mousewheel } from 'swiper';
import 'swiper/css';

Swiper.use([FreeMode, Mousewheel]);

@Component
export class FitGuide extends ThemeComponent {

    private drawerContainer: DrawerContainer|null = null;

    init() {
        this.drawerContainer = document.querySelector('.drawer[data-ref="fitGuide"]') as DrawerContainer;

        const fitGuideButton = this.querySelector('.fit-guide__button') as HTMLButtonElement;
        if (fitGuideButton) {
            fitGuideButton.addEventListener('click', this.openFitGuide.bind(this));
        }

        // Bind close button to restore body scroll
        const closeButton = this.drawerContainer?.querySelector('[data-ref="closeButton"]');
        if (closeButton) {
            closeButton.addEventListener('click', () => {
                document.documentElement.classList.remove('no-scroll');
            });
        }
    }

    async openFitGuide() {
        document.documentElement.classList.add('no-scroll');

        const fitGuideUrl = this.getAttribute('data-fit-guide-url') || '/pages/denim-fit-guide';
        if (!fitGuideUrl) {
            // eslint-disable-next-line no-console
            console.warn('Fit guide URL is not set.');
            return;
        }

        try {
            const templateUrl = `${location.protocol}//${location.host}${fitGuideUrl}`;
            const response = await fetch(templateUrl);
            const html = await response.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const mainContent = doc.querySelector('.main-content');

            if (mainContent) {
                const hero = mainContent.querySelector('.hero');
                const richTextContent = doc.querySelector('.rich-text');
                if (hero) {
                    hero.remove();
                }
                if (richTextContent) {
                    richTextContent.remove();
                }
            }


            if (mainContent && this.drawerContainer) {
                const oldContent = this.drawerContainer.querySelector('.fit-guide-content');
                if (oldContent) { oldContent.remove(); }

                const drawerHeader = this.drawerContainer.querySelector('drawer-header');
                if (drawerHeader) {
                    drawerHeader.insertAdjacentHTML(
                        'afterend',
                        `<div class="fit-guide-content">${mainContent.innerHTML}</div>`
                    );
                } else {
                    // eslint-disable-next-line no-console
                    console.warn('drawer-header not found inside drawerContainer');
                }

                requestAnimationFrame(() => {
                    this.initDrawerSwipers();

                    const collectionName = this.getAttribute('data-collection-handle');
                    if (!collectionName) {return;}

                    setTimeout(() => {
                        const tabButton = this.drawerContainer?.querySelector(
                            `.tabbed-showcase__tab[data-collection="${collectionName}"]`
                        ) as HTMLButtonElement | null;

                        if (tabButton) {tabButton.click();}
                    }, 0);
                });

                this.drawerContainer.toggleOpen();
            }

        } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Error fetching fit guide content:', error);
        }
    }


    private initDrawerSwipers(): void {
        if (!this.drawerContainer) {return;}



        // Select the carousels you want inside the drawer content
        const carousels = this.drawerContainer.querySelectorAll<HTMLElement>(
            '.image-columns__content--sidescroll-wrapper'
        );

        if (!carousels) { return; }

        for (const carousel of carousels) {

            // Destroy if a Swiper is already attached
            const existing = (carousel as HTMLElement & { swiper?: Swiper }).swiper;
            if (existing) {
                existing.destroy(true, true);
            }

            const sw = new Swiper(carousel, {
                freeMode: true,
                spaceBetween: 10,
                slidesPerView: 1.5,
                breakpoints: {
                    768: { slidesPerView: 3.5 },
                    1024: { slidesPerView: 5.5 },
                    1440: { slidesPerView: 3.5 }
                }
            });
        }
    }
}
